<div class="text-center">
  <span
    class="error-code"
    style="text-align: center; width: 100%; display: block; font-size: 10rem"
    >404</span
  >
  <h1 style="text-align: center">This page doesn't exist</h1>
</div>
